import { investigationSpentLine, type InvestigationStop } from "@omnabase/shared";

/** The credits an investigation spent, on its note (the credits-not-ceilings round, part four, rule 1; Q4): the figures come from the
 *  investigation's record (`spent`), never from the note's text. On screen the line "Spent 3 of up to 50 credits" sits on its own under the
 *  note's first line, and the body's own last line (the same words, kept in the stored text) is hidden. A note without figures (the
 *  workspace's own key, an older note) is shown as it is. */
const LAST_SPENT = /\s*<p[^>]*>\s*Spent \d+ of up to \d+ credits?\.\s*<\/p>\s*$/;
const FIRST_BLOCK_END = /<\/(p|h[1-6]|ul|ol|blockquote|pre)>/;
const escape = (s: string) => s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");

export function spentLineOf(m: { spent?: { charged: number; cap: number; stopped: InvestigationStop | null } }): string | null {
  return m.spent ? investigationSpentLine(m.spent.charged, m.spent.cap).replace(/\.$/, "") : null;
}

/** the note's HTML with the spent line under its first block and the body's own last line taken off */
export function withSpentUnderFirstLine(html: string, line: string | null): string {
  if (!line) return html;
  const body = html.replace(LAST_SPENT, "");
  const tag = `<p class="ob-entry__spent">${escape(line)}</p>`;
  const end = FIRST_BLOCK_END.exec(body);
  return end ? `${body.slice(0, end.index + end[0].length)}${tag}${body.slice(end.index + end[0].length)}` : `${tag}${body}`;
}
